import Utils from "../Utils";
import services from "../services";

const strict = true;

const getDefaultState = () => {
  return {
    billsPayments: [],
    numberOfBillsPayments: 0,
    filterCriteriaResults: ""
  };
};

const state = getDefaultState();

const getters = {
  billsPayments: state => state.billsPayments,
  numberOfBillsPayments: state => state.numberOfBillsPayments,
  filterCriteriaResults: state => state.filterCriteriaResults
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_BILLS_PAYMENTS(state, billsPayments) {
    state.billsPayments = billsPayments;
  },
  SET_NUMBER_OF_BILLS_PAYMENTS(state, numberOfBillsPayments) {
    state.numberOfBillsPayments = numberOfBillsPayments;
  },
  SET_FILTER_CRITERIA_RESULTS(state, searchTerm) {
    if (searchTerm) {
      state.filterCriteriaResults = "'" + searchTerm + "'";
    } else {
      state.filterCriteriaResults = "";
    }
  },
  setPagination(state, value) {
    state.pagination = value;
  }
};

const actions = {
  getBillsPayments({ commit }, payload) {
    let apiParams = {
      order: payload.sortDesc[0] ? "DESC" : "ASC",
      orderField: payload.sortBy[0] || "paidDate",
      page: payload.page - 1,
      size: payload.itemsPerPage,
      toSearch: payload.search || ""
    };

    return services.billsService
      .fetchBillsPayments(payload.officeId, apiParams)
      .then(billObj => {
        const groupedBills = groupByCro(billObj.billPaymentList);

        commit("SET_BILLS_PAYMENTS", groupedBills);
        commit("SET_NUMBER_OF_BILLS_PAYMENTS", billObj.numberOfBills);
      })
      .catch(error => {
        commit("SET_BILLS_PAYMENTS", []);
        commit("SET_NUMBER_OF_BILLS_PAYMENTS", 0);

        let errorDialogDetails = {
          ...error
        };

        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "billsPayments";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {
        commit("SET_FILTER_CRITERIA_RESULTS", payload.search);
      });
  },
  exportBillsPaymentsOfficeWithOfficeId({ commit }, payload) {
    return services.billsService
      .exportBillsPaymentsOfficeWithOfficeId(payload.officeId, payload.cro)
      .then(response => response)
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };

        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "billsPayments";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      });
  },
  updatePaginationAndReloadBillsPayments({ commit, dispatch }, pagination) {
    commit("setPagination", pagination);
    dispatch("getBillsPayments", pagination.officeId);
  }
};

function groupByCro(bills) {
  const gruppi = {};

  bills.forEach(bill => {
    const cro = bill.CRO;

    const [valuta, valoreStr] = bill.amount.split(" ");
    const valore = parseFloat(valoreStr);

    if (!gruppi[cro]) {
      gruppi[cro] = {
        CRO: cro,
        numberOfServices: 0,
        amount: 0,
        valuta: valuta
      };
    }

    gruppi[cro].numberOfServices += bill.numberOfServices;
    gruppi[cro].amount += valore;
  });

  return Object.values(gruppi).map(g => ({
    CRO: g.CRO,
    numberOfServices: g.numberOfServices,
    amount: `${g.valuta} ${g.amount.toFixed(2)}`,
    paidDate: bills.find(bill => bill.CRO === g.CRO).paidDate,
    croDate: bills.find(bill => bill.CRO === g.CRO).croDate
  }));
}

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
